import React from "react";
import { styled } from "@mui/system";
import MUIAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";

export const AccordionSummary = styled(
  (props: AccordionSummaryProps) => <MUIAccordionSummary {...props} />,
  {
    name: "AccordionSummary",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiAccordionSummary-root": {
    backgroundColor: theme.palette.primary.inputBackgroundDefault,
    border: "1px solid transparent",
    flexDirection: "row-reverse",
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 6,
    paddingRight: 6,
  },
  "&.MuiAccordionSummary-root:hover": {
    border: "1px solid " + theme.palette.primary.borderActive,
  },
  "&.MuiAccordionSummary-root.Mui-expanded": {
    backgroundColor: theme.palette.primary.surfaceDefault,
    minHeight: 48,
  },
  "&.MuiAccordionSummary-root .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 42,
  },
  "&.MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper": {
    width: 32,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.tertiaryTextDefault,
    transform: "rotate(-90deg)",
  },
  "&.MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper.Mui-expanded":
    {
      transform: "rotate(0deg)",
    },
  "&.MuiAccordionSummary-root .MuiTypography-root.MuiTypography-titleSmall ": {
    fontSize: 16,
    marginLeft: 8,
    width: "40%",
    flexShrink: 0,
  },
  "&.MuiAccordionSummary-root .MuiTypography-root.MuiTypography-body ": {
    color: theme.palette.primary.textSubduedColor,
  },
  "&.MuiAccordionSummary-root .error-icon": {
    color: theme.palette.primary.borderError,
    position: "absolute",
    display: "none",
    right: 16,
    top: 16,
  },
}));
